import { PropsWithChildren } from 'react';

import { cn } from '@/shared/utils/cn';

export const Section = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return <div className={cn('flex flex-col gap-8', className)}>{children}</div>;
};
